const reducer = state => ({
  ...state,
  error: null,
  inProgress: true,
  pending: true,
});

export default reducer;
